var map = {
	"./Fotolia_106332295.png": "a8b4",
	"./Hero_YTbg.jpg": "24b3",
	"./Origins_100_on_Vimeo@2x.png": "7735",
	"./Stanley_Nelson.jpg": "e554",
	"./Starbucks_GlobalAcademy_lockup_horizontal_FINAL-01_(1).svg": "d8d1",
	"./TBW-static-hero.png": "fb2a",
	"./TBW_Secondary_Image_Conversation.jpg": "b4fd",
	"./apple.svg": "990a",
	"./expand-arrow-black.svg": "2c2f",
	"./expand-arrow-green.svg": "a253",
	"./expand-arrow-white.svg": "6669",
	"./expand-arrow.svg": "89d2",
	"./google-play.svg": "b046",
	"./hero-image.png": "afaf",
	"./iconfinder_menu-alt_134216.svg": "8efd",
	"./image-placeholder.png": "04d5",
	"./loading_icon.svg": "34e9",
	"./logo-white.svg": "a266",
	"./logo.svg": "e347",
	"./modal-image.png": "75ef",
	"./starbucks-coffee-logo.svg": "43d0",
	"./trees_flowers_20.jpg": "cada"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";